import React, { memo, useMemo } from "react";
import { HousingItem } from "../../../../pages/Housings/HousingItem";
import type { HousingItem as Housing } from "../../types";

type Props = {
    item: Housing;
    onOpenVariants: (housing: Housing) => void;
    selectedVariantsCount?: number;
};

/** The catalog card stays intact; AI search only supplies a contextual action. */
export const HousingCard: React.FC<Props> = memo(({
    item,
    onOpenVariants,
    selectedVariantsCount = 0,
}) => {
    const variantsCount = useMemo(
        () => item.pricing?.reduce(
            (total, tier) => total + tier.layouts.reduce(
                (layoutsTotal, layout) => layoutsTotal + (layout.paymentPlans?.length ?? 0),
                0,
            ),
            0,
        ) ?? 0,
        [item.pricing],
    );

    const openVariants = () => onOpenVariants(item);

    return (
        <li className={`ai-housing-group ${selectedVariantsCount ? "is-selected" : ""}`}>
            <HousingItem
                as="div"
                housing={item}
                onClick={openVariants}
                action={(
                    <button
                        type="button"
                        className="ai-housing-group__toggle"
                        onClick={(event) => {
                            event.stopPropagation();
                            openVariants();
                        }}
                    >
                        {selectedVariantsCount
                            ? `Выбрано: ${selectedVariantsCount}`
                            : variantsCount ? `Варианты (${variantsCount})` : "Подробнее"}
                    </button>
                )}
            />
        </li>
    );
});

HousingCard.displayName = "HousingCard";
